export default "__VITE_ASSET__FHWOPQJh__"